import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  sidebarCollapsed: false,
  theme: 'light',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { setLoading, toggleSidebar, setTheme } = uiSlice.actions;
export default uiSlice.reducer;